import { Component } from 'react'
import { OperationStart } from 'stylewhere/components'
import { TransferToZoneExtensions } from 'stylewhere/extensions'

export default class ConveyorStart extends Component {
  render() {
    return <OperationStart submitPath="/shipping/conveyor/:opCode/reading" extensions={TransferToZoneExtensions} />
  }
}
